import {PlayParticipantsContainerController} from "./PlayParticipantsContainer";
import {find} from "lodash";


export class ParticipantStateToggleController {
    public app: PlayParticipantsContainerController;
    public league: any;
    public filtering: any;

    public toggleStatusFilter() {
        this.app.filterByStatus(!this.filtering.statusFilter);
    }

    /**
     * Check if checkin is enabled & has started.
     * @returns true if checkIn has started. False if checkIn is disabled.
     */
    public checkInHasStarted(): boolean {
        if (find(["checkIn", "inProgress", "finished"], state => state === this.league.state)) {
            if (!this.league.timeline || this.league.timeline.checkIn) {
                return true;
            }
        }

        return false;
    }
}